// extracted by mini-css-extract-plugin
export default {"container":"artwork-sent_container__rBIHA","greenButton":"artwork-sent_greenButton__CSE-e"};